import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

export const useMessagesTabConfig = () => {
  const { CLIENT_PROFILE } = COMPONENT_TYPES;

  const clientProfilePage = SiteConfigManager.getConfig('config.pages')?.find(
    page => page.type === CLIENT_PROFILE,
  );

  return clientProfilePage?.options?.tabs?.find(tab => tab.type === 'messages');
};
